export const initGTM = ({ gtmId, serverUrl }) => {
  if (!gtmId || !serverUrl) return;

  // Se WordPress (o qualsiasi altra cosa) ha già caricato GTM, non iniettarlo di nuovo.
  const existingGtmScript = document.querySelector(
    `script[src*="gtm.js?id=${gtmId}"]`
  );
  const existingInjectedScript = document.getElementById(`gtm-script-${gtmId}`);
  if (existingGtmScript || existingInjectedScript || window.google_tag_manager) {
    return;
  }


  const script = document.createElement('script');
  script.id = `gtm-script-${gtmId}`;
  script.innerHTML = `
    (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
    new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
    j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;
    j.src='${serverUrl}/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
    })(window,document,'script','dataLayer','${gtmId}');
  `;
  document.head.appendChild(script);

  const existingNoScript = document.getElementById(`gtm-noscript-${gtmId}`);
  if (existingNoScript) return;

  const noscript = document.createElement('noscript');
  noscript.id = `gtm-noscript-${gtmId}`;
  noscript.innerHTML = `
    <iframe src="${serverUrl}/ns.html?id=${gtmId}"
    height="0" width="0" style="display:none;visibility:hidden"></iframe>
  `;
  document.body.insertBefore(noscript, document.body.firstChild);
};